import { TConfig } from '@@/interfaces';

import { AUTO_DISCOUNTS } from '../../autoDiscounts';

const ToggleSCConfig: DeepPartial<TConfig> = {
  auto: {
    addOns: {
      options: {
        oem_parts: {
          copy: {
            label: 'OEM Parts',
          },
        },
      },
      getAddOns: () => [
        'towing_road_services',
        'loss_of_use',
        'ridesharing',
        'loan_lease_payoff',
        'oem_parts',
        'new_car_replacement',
      ],
    },
  },
  autoDiscounts: [
    AUTO_DISCOUNTS.aeb,
    AUTO_DISCOUNTS.continuousInsurance,
    AUTO_DISCOUNTS.defensiveDriver,
    AUTO_DISCOUNTS.distantStudent,
    AUTO_DISCOUNTS.claimFree,
    AUTO_DISCOUNTS.goodStudent,
    AUTO_DISCOUNTS.homeowner,
    AUTO_DISCOUNTS.multiCar,
    AUTO_DISCOUNTS.multiPolicy,
    AUTO_DISCOUNTS.accidentFree,
    AUTO_DISCOUNTS.safeDriving,
    AUTO_DISCOUNTS.teenDriver,
    AUTO_DISCOUNTS.threeYearSafeDriving,
  ],
  visibleCoverages: {
    protectionCoverages: [
      {
        label: 'Underinsured Motorist Bodily Injury',
        key: 'underinsured_motorist_bodily_injury_limit',
      },
    ],
  },
  initialCoverageValues: {
    loan_lease_payoff: 'false',
    loss_of_use: 'null',
    ridesharing: 'false',
  },
};
export default ToggleSCConfig;
